import { jsx, jsxs } from "react/jsx-runtime";
import {
  DefaultColorStyle,
  getColorValue,
  useEditor,
  useValue
} from "@tldraw/editor";
import { useCallback } from "react";
import { useTldrawUiComponents } from "../context/components.mjs";
import { useRelevantStyles } from "../hooks/useRelevantStyles.mjs";
import { useTranslation } from "../hooks/useTranslation/useTranslation.mjs";
import { TldrawUiButton } from "./primitives/Button/TldrawUiButton.mjs";
import { TldrawUiButtonIcon } from "./primitives/Button/TldrawUiButtonIcon.mjs";
import { useTldrawUiOrientation } from "./primitives/layout.mjs";
import {
  TldrawUiPopover,
  TldrawUiPopoverContent,
  TldrawUiPopoverTrigger
} from "./primitives/TldrawUiPopover.mjs";
function MobileStylePanel() {
  const editor = useEditor();
  const msg = useTranslation();
  const { orientation } = useTldrawUiOrientation();
  const relevantStyles = useRelevantStyles();
  const color = relevantStyles?.get(DefaultColorStyle);
  const currentColor = useValue(
    "mobile style panel current color",
    () => {
      const colors = editor.getCurrentTheme().colors[editor.getColorMode()];
      return color?.type === "shared" ? getColorValue(colors, color.value, "solid") : getColorValue(colors, "black", "solid");
    },
    [editor, color]
  );
  const disableStylePanel = useValue(
    "disable style panel",
    () => editor.isInAny("hand", "zoom", "eraser", "laser"),
    [editor]
  );
  const handleStylesOpenChange = useCallback(
    (isOpen) => {
      if (!isOpen) {
        editor.updateInstanceState({ isChangingStyle: false });
      }
    },
    [editor]
  );
  const { StylePanel } = useTldrawUiComponents();
  if (!StylePanel) return null;
  return /* @__PURE__ */ jsxs(TldrawUiPopover, { id: "mobile style menu", onOpenChange: handleStylesOpenChange, children: [
    /* @__PURE__ */ jsx(TldrawUiPopoverTrigger, { children: /* @__PURE__ */ jsx(
      TldrawUiButton,
      {
        type: "tool",
        "data-testid": "mobile-styles.button",
        style: {
          color: disableStylePanel ? "var(--tl-color-muted-1)" : currentColor
        },
        title: msg("style-panel.title"),
        disabled: disableStylePanel,
        children: /* @__PURE__ */ jsx(
          TldrawUiButtonIcon,
          {
            icon: disableStylePanel ? "blob" : color?.type === "mixed" ? "mixed" : "blob"
          }
        )
      }
    ) }),
    /* @__PURE__ */ jsx(TldrawUiPopoverContent, { side: orientation === "horizontal" ? "top" : "right", align: "end", children: StylePanel && /* @__PURE__ */ jsx(StylePanel, { isMobile: true }) })
  ] });
}
export {
  MobileStylePanel
};
//# sourceMappingURL=MobileStylePanel.mjs.map
